import { type FormFieldMeta } from 'types/Squares/WorkOrderManagement/work.order.creation.form.types';

export const fieldMetadata: Record<string, FormFieldMeta> = {
  assetId: { label: 'Asset ID', required: true, step: 'creation' },
  assetType: { label: 'Asset Type', required: false, step: 'creation' },
  make: { label: 'Make', required: false, step: 'creation' },
  model: { label: 'Model', required: false, step: 'creation' },
  partNumber: { label: 'Part Number', required: false, step: 'creation' },
  componentId: { label: 'Component', required: false, step: 'creation' },
  subComponentId: { label: 'Sub Component', required: false, step: 'creation' },
  maintenanceType: {
    label: 'Maintenance Type',
    required: true,
    step: 'creation',
  },
  // source: { label: 'Source', required: true, step: 'creation' },
  priority: {
    label: 'Priority',
    required: true,
    step: 'creation',
    initialValue: 'Medium',
  },
  creationDate: {
    label: 'Creation Date',
    required: false,
    step: 'creation',
    initialValue: null,
  },
  plannedStartDate: {
    label: 'Planned Start Date',
    required: true,
    step: 'creation',
  },
  plannedEndDate: {
    label: 'Planned End Date',
    required: true,
    step: 'creation',
  },
  description: { label: 'Description', required: true, step: 'creation' },
  status: {
    label: 'Status',
    required: false,
    step: 'creation',
    initialValue: '',
  },
  assignedUserId: {
    label: 'Technician ID',
    required: false,
    step: 'creation',
  },
  estimatedTime: {
    label: 'Estimated Time',
    required: false,
    step: 'creation',
  },
  estimatedTimeUnit: {
    label: 'Estimated Time Unit',
    required: false,
    step: 'creation',
    initialValue: 'Hours',
  },

  actualStartDate: {
    label: 'Actual Start Date',
    required: true,
    step: 'completion',
  },
  actualEndDate: {
    label: 'Actual Completion Date',
    required: true,
    step: 'completion',
  },
  maintenanceActionPerformed: {
    label: 'Maintenance Action',
    required: false,
    step: 'completion',
    initialValue: '',
  },
  actualTime: {
    label: 'Actual Time Value',
    required: false,
    step: 'completion',
  },
  actualTimeUnit: {
    label: 'Actual Time Unit',
    required: false,
    step: 'completion',
    initialValue: 'Hours',
  },
  partsCost: {
    label: 'Parts Cost',
    required: false,
    step: 'completion',
    initialValue: 0,
  },
  laborCost: {
    label: 'Labor Cost',
    required: true,
    step: 'completion',
    initialValue: 0,
  },
  totalCost: {
    label: 'Total Cost',
    required: true,
    step: 'completion',
    initialValue: 0,
  },
  currencyCode: {
    label: 'Currency',
    required: false,
    step: 'completion',
    initialValue: 'USD',
  },
};

export const issueCreationFields = [
  'partNumber',
  'componentId',
  'subComponentId',
  'plannedStartDate',
  'plannedEndDate',
  'description',
  'workInstruction',
  'assignedUserId',
];

export const issueAssignmentFields = ['estimatedTime', 'estimatedTimeUnit'];

export const issueCompletionFields = [
  'actualStartDate',
  'actualEndDate',
  'maintenanceActionPerformed',
  'actualTime',
  'actualTimeUnit',
  'partsCost',
  'laborCost',
  'totalCost',
  'currencyCode',
];

export const ISSUE_TYPE_OPTIONS = [
  { value: 'Preventive', label: 'Preventive' },
  { value: 'Corrective', label: 'Corrective' },
  { value: 'Inspect', label: 'Inspect' },
];

export const SOURCE_OPTIONS = [
  { value: 'Manual', label: 'Manual' },
  { value: 'X.Inspect', label: 'X.Inspect' },
  { value: 'X.Parts', label: 'X.Parts' },
  { value: 'OEM Recommendation', label: 'OEM Recommendation' },
];

export const PRIORITY_OPTIONS = [
  { value: 'Low', label: 'Low' },
  { value: 'Medium', label: 'Medium' },
  { value: 'High', label: 'High' },
];
export const CURRENCY_OPTIONS = [
  { label: 'Dollar ($)', value: 'USD' },
  { label: 'Pound (£)', value: 'GBP' },
  { label: 'Rupee (₹)', value: 'INR' },
];
